import { render, staticRenderFns } from "./Citaat.vue?vue&type=template&id=22347be9&"
import script from "./Citaat.vue?vue&type=script&lang=js&"
export * from "./Citaat.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Citaat.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports